import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

const statusStyles: Record<string, { badge: string; dot: string }> = {
  DRAFT: { badge: 'bg-gray-50 text-gray-600 ring-gray-500/20', dot: 'bg-gray-400' },
  ACTIVE: { badge: 'bg-primary-50 text-primary-700 ring-primary-600/20', dot: 'bg-primary-500' },
  PARTIALLY_FULFILLED: { badge: 'bg-orange-50 text-orange-700 ring-orange-600/20', dot: 'bg-orange-500' },
  FULFILLED: { badge: 'bg-success-50 text-success-700 ring-success-600/20', dot: 'bg-success-500' },
  CANCELLED: { badge: 'bg-danger-50 text-danger-700 ring-danger-600/20', dot: 'bg-danger-500' },
  EXPIRED: { badge: 'bg-warning-50 text-warning-800 ring-warning-600/20', dot: 'bg-warning-500' },
};

const fallback = statusStyles.DRAFT!;

export function statusDotClass(status: string): string {
  return (statusStyles[status] ?? fallback).dot;
}

/** Prescription status pill, shared by doctor, pharmacist and patient views. */
export function StatusBadge({ status, className }: { status: string; className?: string }) {
  const { t } = useTranslation();
  const style = statusStyles[status] ?? fallback;
  return (
    <span className={clsx('badge', style.badge, className)}>
      <span className={clsx('h-1.5 w-1.5 rounded-full', style.dot)} />
      {t(`prescription.status.${status.toLowerCase()}`)}
    </span>
  );
}
